import(/* webpackMode: "eager" */ "/var/www/nextjs-preview/src/app/error.tsx");
